import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import styles from "./drug_admin_table.module.css";
import { get } from "util/requests";
import router from "routes";
import LoadingButton from "@mui/lab/LoadingButton";
import { ThemeProvider } from "@mui/material";
import colors from "colors";
import { theme } from "config";

const name_map = (n) => {
  const names = {
    expiry_buffer_days: "Expiry Lead Time (days)",
  };
  return names[n];
};
export default function DrugAdminTable(props) {
  const { studyConfig } = props;
  const study_id = useSelector((state) => state.study.active_study_id);
  const [drugs, setDrugs] = useState([]);
  useEffect(() => {
    get(`/drug_admin`).then((ret) => setDrugs(ret.data));
  }, []);
  let columns = [
    { field: "name", headerName: "Name", width: 240 },
    {
      field: "expiry_buffer_days",
      headerName: name_map("expiry_buffer_days"),
      width: 200,
      renderCell: ({ row }) => row.data.expiry_buffer_days,
    },
  ];

  return (
    <div>
      <LoadingButton
        variant="contained"
        loading={false}
        style={{ marginBottom: 6 }}
        onClick={() => router.navigate("/admin/drug/add")}
      >
        ADD DRUG
      </LoadingButton>
      <div style={{ height: 600, width: "100%" }}>
        <ThemeProvider theme={theme}>
          <DataGrid
            rows={drugs}
            columns={columns}
            disableColumnSelector
            disableRowSelectionOnClick
            disableColumnMenu
            pageSize={5}
            rowsPerPageOptions={[5]}
            hideFooterSelectedRowCount
            pageSizeOptions={[]}
            columnHeaderHeight={34}
            rowHeight={34}
            sx={{
              boxShadow: 0,
              border: 1,
              borderColor: "#f0f0f0",
              "& .MuiDataGrid-cell:hover": {
                color: "#8349fd",
                cursor: "pointer",
              },
              "& .MuiDataGrid-topContainer .MuiDataGrid-columnHeader ": {
                // backgroundColor: "#f7f3fe",
                backgroundColor: colors.table_header_background,
              },
              "& .MuiDataGrid-topContainer .MuiDataGrid-filler ": {
                // backgroundColor: "#f7f3fe",
                backgroundColor: colors.table_header_background,
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: 700,
                color: "#333",
              },
            }}
            onRowClick={(row) => {
              router.navigate(`/admin/drug/${row.id}`);
            }}
          />
        </ThemeProvider>
      </div>
    </div>
  );
}
